/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S3_Apikey_LabelInputs */

const tr_mesafeli_s3_apikey_label = /** @type {(inputs: Mesafeli_S3_Apikey_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazaryeri API Anahtarı:`)
};

const en_mesafeli_s3_apikey_label = /** @type {(inputs: Mesafeli_S3_Apikey_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace API Key:`)
};

const de_mesafeli_s3_apikey_label = /** @type {(inputs: Mesafeli_S3_Apikey_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplatz-API-Schlüssel:`)
};

const ru_mesafeli_s3_apikey_label = /** @type {(inputs: Mesafeli_S3_Apikey_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ маркетплейса:`)
};

/**
* | output |
* | --- |
* | "Marketplace API Key:" |
*
* @param {Mesafeli_S3_Apikey_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s3_apikey_label = /** @type {((inputs?: Mesafeli_S3_Apikey_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S3_Apikey_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s3_apikey_label(inputs)
	if (locale === "de") return de_mesafeli_s3_apikey_label(inputs)
	if (locale === "ru") return ru_mesafeli_s3_apikey_label(inputs)
	return tr_mesafeli_s3_apikey_label(inputs)
});